import { PatientPharmacy } from "~/common/types/pharmacies";
import {
  createPatientPharmacy,
  deletePatientPharmacy,
  getPatientPharmacies,
  setDefaultPatientPharmacy,
  updatePatientPharmacy,
} from "~/patients/api/pharmacies";
import {
  createTeamMemberPatientPharmacy,
  deleteTeamMemberPatientPharmacy,
  getTeamMemberPatientPharmacies,
  setDefaultTeamMemberPatientPharmacy,
  updateTeamMemberPatientPharmacy,
} from "~/providers/api/patientPharmacies";
import { patientPharmaciesQueryKey } from "./patientPharmaciesQueryKey";

export const getPatientPharmaciesApi = (patientId?: string) => {
  if (patientId) {
    return {
      queryKey: patientPharmaciesQueryKey(patientId),
      getPharmacies: () => getTeamMemberPatientPharmacies(patientId),
      createPharmacy: (pharmacy: PatientPharmacy) =>
        createTeamMemberPatientPharmacy(patientId, pharmacy),
      updatePharmacy: (pharmacy: PatientPharmacy, pharmacyId: string) =>
        updateTeamMemberPatientPharmacy(patientId, pharmacy, pharmacyId),
      deletePharmacy: (pharmacyId: string) =>
        deleteTeamMemberPatientPharmacy(patientId, pharmacyId),
      setDefaultPharmacy: (pharmacyId: string) =>
        setDefaultTeamMemberPatientPharmacy(patientId, pharmacyId),
    };
  }

  return {
    queryKey: patientPharmaciesQueryKey(),
    getPharmacies: getPatientPharmacies,
    createPharmacy: createPatientPharmacy,
    updatePharmacy: updatePatientPharmacy,
    deletePharmacy: deletePatientPharmacy,
    setDefaultPharmacy: setDefaultPatientPharmacy,
  };
};
